import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3acdcf4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-organizations-listing" }

import { computed, PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { EUserOrganizationCard } from '@/entities/EUserOrganizationCard'
import { OrganizationType } from '@/shared/types'
import { getDateDistance } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  organizations: Array as PropType<OrganizationType[]>,
},
  setup(__props) {



const router = useRouter()
const route = useRoute()

const activeOrganizationId = computed(() =>
  route.params.organizationId === 'all'
    ? 0
    : Number(route.params.organizationId)
)

const isSubscriptionEnded = (date: Date): boolean => {
  return !getDateDistance(date)
}

const handleChooseOrganization = (organizationId: number): void => {
  router.push({
    name: 'UsersShowPage',
    params: {
      userId: route.params.userId,
      organizationId,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.organizations, (organization) => {
      return (_openBlock(), _createBlock(_unref(EUserOrganizationCard), {
        organization: organization,
        key: organization.id,
        active: _unref(activeOrganizationId) === organization.id,
        blocked: 
        !organization.package_count ||
        isSubscriptionEnded(organization.block_at)
      ,
        onClick: ($event: any) => (handleChooseOrganization(organization.id))
      }, null, 8, ["organization", "active", "blocked", "onClick"]))
    }), 128))
  ]))
}
}

})